import { HTTPError } from "griptonite-api-client/client";

export function transformValidationErrorToErrorsArray(error: HTTPError) {
  const errors: ErrorDetail[] = [];
  if ("detail" in error.jsonData && error.jsonData) {
    const jsonData: ErrorResponse = error.jsonData;
    recurseErrorObj("", jsonData.detail, errors);
  }
  return errors;
}
export type ErrorDetail = {
  path: string;
  code: string;
  message: string;
};
type ErrorResponseNode = { message: string; code: string }[] | { [key: string]: ErrorResponseNode };

export type ErrorResponse = {
  detail: Record<string, ErrorResponseNode>;
};

export const recurseErrorObj = (path: string, obj: ErrorResponseNode, errors: ErrorDetail[]) => {
  if (Array.isArray(obj)) {
    obj.forEach((item) => {
      errors.push({
        ...item,
        path,
      });
    });
  } else if (typeof obj === "object") {
    for (const key in obj) {
      recurseErrorObj([...(path ? [path] : []), key].join("."), obj[key], errors);
    }
  }
};

export const handleFormError = <T>(
  error: unknown,
  methods: {
    setError: (name: T, error: { type: string; message: string }) => void;
  },
  prefix?: string,
) => {
  console.warn("Form submission error", error);
  const withPrefix = (s: string) => (prefix ? `${prefix}.${s}` : s);
  if (error instanceof HTTPError && error.response.status === 400 && error.jsonData) {
    const errors = transformValidationErrorToErrorsArray(error);
    errors.forEach((error) => {
      // oxlint-disable-next-line typescript/no-explicit-any
      methods.setError(withPrefix(error.path) as T, {
        type: error.code,
        message: error.message,
      });
    });
  }
};
